import apiUrl from '../../../../constants'
import axios from 'axios'
import PageTracker from '../../../../common/PageTrackerHelper'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment';
import {Validator} from 'vee-validate'

export default {
    name: 'ScanTallyReport',
    components: {
        VueElementLoading
    },
    mixins:[PageTracker],
    data: function() {
        return {
            ScantallyData:[],
            ScantallyMasterData:[],
            ScantallyShipmentData:[],
            ShippingId:'',
            BatchID:'',
            awbArray1:[],
            isShipmentLoader:false,
            isLoading: false,
            showTables: false,
        }
     },
async mounted(){
  let validateUser = await this.validateJwtToken();
  var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
  var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
  var plaintext = bytes.toString(CryptoJS.enc.Utf8);
  var userdetail = JSON.parse(plaintext)
  this.userHubId = userdetail.hubdetails[0] == undefined ? 0 : userdetail.hubdetails[0]
  this.createdBy = userdetail.username;
  this.userid = userdetail.userid;
},
filters: {
  changeDateFormat: function(date) {
    if (date != null || date != '') {
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }
  }
},
methods : {
    validateForm1(scope) {
        this.$validator.validateAll(scope).then(result => {
          if (result) {
            if(this.BatchID == '' && this.ShippingId == ''){
              this.$alertify.error('Please Enter Either BatchId OR ShippingId')
            }
            else {
            this.isShipmentLoader = true;
            this.awbArray1 = [];
            this.isLoading = true;
            this.ScantallyData=[];
            this.ScantallyMasterData=[];
            this.ScantallyShipmentData=[];

            let shippingidsWithNextLine = this.ShippingId.split("\n").map(String);
            let shippingidsWithComma = this.ShippingId.split(",").map(String);
            if(shippingidsWithNextLine.length > 1) {

              $.each(shippingidsWithNextLine, (key,sid)=>{
                if(sid != null && sid !=''){
                  this.awbArray1.push(sid.trim());
                }
              })
            } else if(shippingidsWithComma.length >= 1){

              $.each(shippingidsWithComma, (key,sid)=>{
                if(sid != null && sid !=''){
                  this.awbArray1.push(sid.trim());
                }
              })
            }

            let payload ={};
            if(this.BatchID != ''){
                payload.BatchId = this.BatchID
            }
            if(this.BatchID !='' && this.ShippingId !=''){
                payload.BatchId = this.BatchID,
                payload.ShippingId = this.awbArray1
            }
            if(this.ShippingId){
                payload.ShippingId = this.awbArray1
            }

            axios.post(apiUrl.api_url_for_scantally + 'shipmentscantally/get/details/by/batchid/shippingid', payload)
            .then((response) => {
                if(response.data.code===200){
                    console.log(response.data.data);
                    response.data.data.forEach(obj => {
                        if(obj.mastertabledata){
                            this.ScantallyMasterData = obj.mastertabledata;
                        }
                        else if(obj.Scantallytabledata){
                            this.ScantallyData = obj.Scantallytabledata;
                        }
                        else if(obj.ScantallyshipmentData){
                            this.ScantallyShipmentData = obj.ScantallyshipmentData;
                        }
                    });
                }
                else {
                    this.ScantallyData=[];
                    this.ScantallyMasterData=[];
                    this.ScantallyShipmentData=[];
                    this.$alertify.error('No Shipments found')
                }
                this.isShipmentLoader=false;
                this.isLoading = false;
                this.showTables = true;
            })
            .catch((httpException) => {
                  this.$alertify.error("Shipment data not found");
                  console.error('exception is:::::::::', httpException)
                  this.isShipmentLoader=false;
                  this.isLoading = false;
            })
           }
          }
          })
      },

      clear(){
        this.ScantallyData = '',
        this.ScantallyMasterData = '',
        this.ScantallyShipmentData = '',
        this.ShippingId = '',
        this.BatchID = '',
        this.isShipmentLoader=false,
        this.isLoading = false;
        this.showTables = false;
        this.$validator.reset();
        this.errors.clear();
         }
      }
    }



// WEBPACK FOOTER //
// ./src/views/components/ScanTally/ScanTallyReport/ScanTallyReport.component.js